import styled from "styled-components";
import { ProjectColor } from "../../../utils/tokens/projectColors";

const Project = process.env.REACT_APP_PROJECT;

export const ButtonCustomStyle = styled.button`
  display: flex;
  height: 44px;
  width: fit-content;
  padding: 0 20px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: ${ProjectColor[Project]};

  color: #fff;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.48px;
`;
